import React from 'react'
import { Select, DatePicker, Input, Button} from 'antd'
import moment from 'moment'
import { AddTag } from '../index'
import ChannelSelect from '../ChannelSelect'
import './index.less'
import * as GLOBAL from './../../../../utils/global'
import { isObject } from './../../../../utils'
const { Option } = Select
const dateFormat = 'YYYY-MM-DD'

export default class Search extends React.Component {
	state = {
		filterList: {
			st_type: {
				label: '内容形式',
				type: 'term',
				value: '全部'
			},
			st_review: {
				label: '审核状态',
				type: 'term',
				key: 'st_review',
				value: '全部'
			},
			st_authorize_date_e: {
				label: '有效结束时间',
				type: 'range',
				key: 'st_authorize_date_e',
				value: '',
				operator: 'lte'
			},
			id: {
				label: '内容id',
				type: 'term',
				key: 'id',
				value: ''
			},
			st_text_title: {
				label: '标题',
				type: 'match_phrase',
				key: 'st_text_title',
				value: ''
			},
			st_create_work: {
				label: '创建人',
				type: 'term',
				key: 'st_create_work',
				value: ''
			},
			st_create_time: {
				label: '创建时间',
				type: 'range',
				key: 'st_create_time',
				gte: "",
				lte: "",
				format: "yyyy-MM-dd HH:mm:ss",
				value: ''
			},
			st_update_time: {
				label: '最后修改时间',
				type: 'term',
				key: 'st_update_time',
				value: ''
			},
			sort: {
				label: '',
				key: 'sort',
				value: 'st_update_time'
			},
			st_text_issuechannel_ids: {
				label: '频道',
				type: 'match',
				key: 'st_text_issuechannel_ids',
				value: ''
			}
		},
		datePicker: {
			st_authorize_date_e: '',
			st_update_time: ''
		},
		contentTypeList: [],
		contentTagList: []
	}
	constructor(props: any) {
		super(props)
		this.getTypeList()
	}
	componentDidMount() {
		// if(this.props.where === 'waitReview') {}
		// 取缓存的值初始化
		const jumpBeforeParams = localStorage.getItem('jumpBeforeParams')
		if(!jumpBeforeParams) return
		const filter = JSON.parse(jumpBeforeParams).query.bool.filter
		const { filterList } = this.state
		const filterStash= {}
		const objectRecursion = (obj, value) => {
			const key = Object.keys(obj)[0]
			if (!key) return
			if(key.startsWith('st_')) {
				value[key] =obj[key]
				return value
			} else if(isObject(obj[key])){
				objectRecursion(obj[key], value)
			}
		}
		for(let i = 0; i < filter.length; i++) {
			objectRecursion(filter[i], filterStash)
		}
		Object.keys(filterStash).map(key => {
			filterList[key].value = filterStash[key]
		})
	}
	async getTypeList() {
		const contentTypeList = await GLOBAL.getContentType('list')
		this.setState({
			contentTypeList
		})
	}
	selectChange(key: string, value: any) {
		const { filterList } = this.state
		filterList[key].value = value
		this.setState({
			filterList
		})
	}
	inputChange(key: string, event: any) {
		const { filterList } = this.state
		filterList[key].value = event.target.value
		this.setState({
			filterList
		})
	}
	datePickerChange(key: any, value: any) {
		const { filterList, datePicker } = this.state
		filterList[key].value = value ? moment(value).format(dateFormat) : ''
		datePicker[key] = value
		this.setState({
			filterList,
			datePicker
		})
	}
	createTimeChange(key: any, value: any) {
		const { filterList } = this.state
		if (!value) {
			filterList[key].value = ''
			filterList[key].gte = ''
			filterList[key].lte = ''
		} else {
			const [gte, lte] = value
			filterList[key].value = value
			filterList[key].gte = moment(gte).format(dateFormat) + ' 00:00:00'
			filterList[key].lte = moment(lte).format(dateFormat) + ' 23:59:59'
		}
		this.setState({
			filterList,
		})
	}
	reset() {
		const { filterList, datePicker } = this.state
		localStorage.removeItem('jumpBeforeParams')
		localStorage.removeItem('jumpBeforepageNo')
		// 清空 筛选项
		Object.keys(filterList).forEach(function(key){
			if(key === 'sort') {
				filterList[key].value = 'st_update_time'
			} else if (key === 'range') {
				filterList[key].gte = ''
				filterList[key].lte = ''
				filterList[key].value = ''
			} else {
				filterList[key].value = ''
			}
		})
		datePicker['st_update_time'] = ''
		datePicker['st_authorize_date_e'] = ''
		// 清空标签
		if(this.props.where !== 'waitReview') {
			this.refs.addTagRef.reset()
		}
		this.setState({
			filterList
		})
	}
	getSearch() {
		// 搜索 处理 filterList
		const { filterList } = this.state
		const filter = []
		// 创建除标签以外的搜索对象
		Object.keys(filterList).forEach(key => {
			if(filterList[key].value !== '全部' && filterList[key].value !== '' && key !== 'sort') {
				let data = {}
				data['bool'] = {}
				data['bool']['filter'] = {}
				data['bool']['filter'][filterList[key].type] = {}
				if(key.startsWith('st_authorize_date_e')) {
					data['bool']['filter'][filterList[key].type][key] = {}
					data['bool']['filter'][filterList[key].type][key][filterList[key]['operator']] = filterList[key].value
				} else if (key.startsWith('st_create_time')) {
					if (filterList[key].gte) {
						data = {}
						data[filterList[key].type] = {}
						data[filterList[key].type][key] = {}
						data[filterList[key].type][key].gte = filterList[key].gte
						data[filterList[key].type][key].lte = filterList[key].lte
						data[filterList[key].type][key].format = filterList[key].format
					} else {
						data = null
					}
				} else {
					data['bool']['filter'][filterList[key].type][key] = filterList[key].value
				}
				data && filter.push(data)
			}
		})
		console.log('filter', filter)
		if(this.props.where !== 'waitReview') {
			// 获取标签搜索对象
			const condition = this.refs.addTagRef.getConditionList()

			if(JSON.stringify(condition) !== '{}') {
				filter.push(condition)
			}
		}
		filter.push({
			bool: {
				filter: {
					term: {
						is_del: "0"
					}
				}
			}
		})
		const query = {
			bool: {
				filter: filter
			}
		}
		this.props.getContentList({ query: filter.length > 0 ? query : '', sort: filterList.sort.value })
	}

	render() {
		const { contentTypeList, filterList, datePicker } = this.state
		const contentTypeNode = contentTypeList.map(item => {
			return (
				<Option key={item.id} value={item.id} >{item.name}</Option>
			)
		})

		const checkList = [{
			label: '全部',
			value: '全部'
		},{
			label: '已通过',
			value: 'r0'
		},{
			label: '未审核',
			value: 'r1'
		},{
			label: '未通过',
			value: 'r4'
		},{
			label: '法务待审核',
			value: 'r3'
		}]
		const checkNode = checkList.map(item => {
			return (
				<Option key={item.label} value={item.value} >{item.label}</Option>
			)
		})
		return (
			<div className={`search-wrap clearfix work-search-wrap`}>
				<div className="row">
					<div className="col w168">
						<span className="label w40">标题</span>
						<Input
							style={{ width: '70%' }}
							value={filterList.st_text_title.value}
							onChange={this.inputChange.bind(this, 'st_text_title')}
						/>
					</div>
					<div className="col w196">
						<span className="label w66">内容形式</span>
						<Select
							style={{ width: '60%' }}
							value={filterList.st_type.value}
							onChange={this.selectChange.bind(this, 'st_type')}
						>
							<Option value="全部">全部</Option>
							{contentTypeNode}
						</Select>
					</div>
					<div className="col w196">
						<span className="label w66">审核状态</span>
						<Select
							style={{ width: '60%' }}
							value={filterList.st_review.value}
							onChange={this.selectChange.bind(this, 'st_review')}
						>
							{checkNode}
						</Select>
					</div>
					<div className="col w182">
						<span className="label w52">创建人</span>
						<Input
							style={{ width: '65%' }}
							value={filterList.st_create_work.value}
							onChange={this.inputChange.bind(this, 'st_create_work')}
						/>
					</div>
					<div className="col w190">
						<span className="label w55">创建时间</span>
						<DatePicker.RangePicker onChange={this.createTimeChange.bind(this, 'st_create_time')}/>
					</div>
					{this.props.where !== 'waitReview' ?
						<>
							<div className="col w154">
								<span className="label w25">ID</span>
								<Input
									style={{ width: '77%' }}
									value={filterList.id.value}
									onChange={this.inputChange.bind(this, 'id')}
								/>
							</div>
							<div className="col w295">
								<span className="label w66">有效时间</span>
								<DatePicker onChange={this.datePickerChange.bind(this, 'st_authorize_date_e')}/>
							</div>
						</>
						:
						<>
							<div className="col w180">
								<Button type="primary" onClick={this.getSearch.bind(this)}>搜索</Button>
								<Button type="primary" style={{margin: '0 0 0 10px'}} onClick={this.reset.bind(this)}>重置</Button>
							</div>
						</>
					}
				</div>
				{this.props.where !== 'waitReview' &&
					<>
						<div className="row">
							<div className="col fl w168">
								<span className="label w40">频道</span>
								<ChannelSelect handleChange={this.inputChange.bind(this, 'st_text_issuechannel_ids')} />
							</div>
							<div className="col fl w295">
								<span className="label w94">最后修改时间</span>
								<DatePicker
									format={dateFormat}
									value={datePicker.st_update_time}
									onChange={this.datePickerChange.bind(this, 'st_update_time')}
								/>
							</div>
							<AddTag ref="addTagRef"/>
							<div className="search-btn">
								{/* <div className="col w217">
									<Select
										style={{ width: '100%'}}
										value={filterList.sort.value}
										onChange={this.selectChange.bind(this, 'sort')}
									>
										<Option value="st_update_time">最后修改时间</Option>
										<Option value="st_create_time">创建时间</Option>
									</Select>
								</div> */}
								<Button type="primary" onClick={this.getSearch.bind(this)}>搜索</Button>
								<Button type="primary" onClick={this.reset.bind(this)}>重置</Button>
							</div>
						</div>
					</>
				}
			</div>
		)
	}
}